import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a5c54e48")

_pushScopeId("data-v-a5c54e48")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" お客様情報着信一覧 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("着信一覧から登録する患者様情報を選択して下さい。")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("着信患者情報と仮登録患者をマッチングして登録する場合は、仮登録患者一覧からその患者を選択してください。")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("(電話番号が一致している場合、仮登録患者が自動で選択されます)")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("患者を選択できたら「登録」ボタンを押してください。")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("または、着信患者が誤りの場合は「着信を削除」を押してください。")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("着信を削除 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("登録 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("選択された着信情報を登録してもいいですか？ ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("選択された着信情報と仮登録患者をマッチングして登録します？登録してもいいですか？ ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("選択された着信情報を削除してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_description = _resolveComponent("description")
  const _component_patient_answer_list = _resolveComponent("patient-answer-list")
  const _component_temporary_patient_list = _resolveComponent("temporary-patient-list")
  const _component_vue_two_column_content_even = _resolveComponent("vue-two-column-content-even")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_description, null, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      (_ctx.temporaryPatients.length>0)
        ? (_openBlock(), _createBlock(_component_description, { key: 0 }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.temporaryPatients.length>0)
        ? (_openBlock(), _createBlock(_component_description, { key: 1 }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_description, null, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_description, null, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_two_column_content_even, null, {
            left: _withId(() => [
              _createVNode(_component_patient_answer_list)
            ]),
            right: _withId(() => [
              _createVNode(_component_temporary_patient_list)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        right: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "delete",
            disabled: _ctx.selectedAnswerId==='',
            onClick: _ctx.onDelete
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "warning",
            disabled: !_ctx.matched,
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmNoMatchRef",
        onYes: _ctx.yesNoMatch
      }, {
        default: _withId(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "confirmMatchRef",
        onYes: _ctx.yesMatch
      }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "confirmDeleteRef",
        onYes: _ctx.yesDelete
      }, {
        default: _withId(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})